<template>
  <div class="hf fl">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'RadioGroup'
};
</script>

<style lang="scss" scoped>
</style>
